import React from 'react';
import styled from 'styled-components';
import I10n from '../features/i10n';
import { SECONDARY_COLOR } from '../color-constants';
import Checkbox from '../atoms/checkbox';
import LicenceSelectorQuestion from './licence_selector_question';
import MultiLineText from './multi_line_text';
import DescriptionModal from '../features/modals/modal-description-text';
import { answerIsActive } from '../features/screens/licence_selector_screen/utils';

const Card = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: row;
  padding: 12px 16px;
  gap: 12px;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  border: 2px solid transparent;

  ${props => props.$checked ? `border: 2px solid ${SECONDARY_COLOR};border: 2px solid var(--se-primary, ${SECONDARY_COLOR});` : '' }
  ${props => props.$isDisabled ? `opacity: 0.5; cursor: not-allowed;` : '' }
`;

const TopRow = styled.div`
  display: flex;
  flex: 1 1 0px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
`;

const TitleAndCheckboxWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

const CheckboxContainer = styled.div`
  margin-right: 10px;
`;

const TitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  align-items: center;
  ${props => props.$disabled ? 'cursor: not-allowed;' : ''}
`;

const Title = styled.span`
  margin: 0;
  font-size: 18px;
  color: #000000;
  font-weight: 700;
`;

const ChildQuestionsWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  flex: 1 1 0px;
  align-items: flex-end;
`;

const KnowMoreWrapper = styled.div`
  color: rgba(0, 117, 163, 1);
  display: none;

  @media (max-width: 800px) {
    display: flex;
    flex: 1 1 0px;
    justify-content: flex-end;
    white-space: nowrap;
  }
`;

const KnowMoreLabel = styled.p`
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

const MultiLineTextWrapper = styled.div`
  @media (max-width: 800px) {
    display: none;
  }
`;

class LicenceSelectorCheckCardV2 extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
  }

  toggleModal = (event) => {
    event.stopPropagation();
    this.setState({ showModal: !this.state.showModal });
  }

  render() {
    const { answer, userAnswers, setAnswer, activeQuestions } = this.props;

    const isSelectable = answer.disabled;
    const isSelected = userAnswers[answer.criteria] === answer.value;
    const isDisabled = !answerIsActive(answer, userAnswers) && answer.disableOnly;

    return (
      <Card $checked={isSelected} $isDisabled={isDisabled}>
        <TopRow>
          <TextContainer>
            <TitleRow
              $disabled={isSelectable || isDisabled}
              onClick={(event) => {
                event.stopPropagation();
                if (!isSelectable || isDisabled) {
                  const isSelected = userAnswers[answer.criteria] === answer.value;
                  if (isSelected) {
                    setAnswer(answer.criteria, null);
                  } else {
                    setAnswer(answer.criteria, answer.value);
                  }
                }
               }}
            >
              <TitleAndCheckboxWrapper>
                {!isSelectable && <CheckboxContainer>
                  <Checkbox
                    size={18}
                    checked={isSelected}
                  />
                </CheckboxContainer>}
                <Title>
                  {I10n.getOrDefault(`screen.licence_selector.modal.answer.name.${answer.labelKey}`, answer.name)}
                </Title>
              </TitleAndCheckboxWrapper>
              {answer.hint && <KnowMoreWrapper>
                <KnowMoreLabel onClick={this.toggleModal}>{I10n.get("screen.licence_selector.know_more")}</KnowMoreLabel>
              </KnowMoreWrapper>}
            </TitleRow>
            {answer.hint && <MultiLineTextWrapper>
                <MultiLineText text={I10n.getOrDefault(`screen.licence_selector.modal.answer.hint.${answer.labelKey}`, answer.hint)}>
                </MultiLineText>
              </MultiLineTextWrapper>
            }
            {isSelected && activeQuestions.filter(question => {
              return question.parentAnswer === answer.key;
            }).map((question, idx) => {
              return (
                <ChildQuestionsWrapper key={idx}>
                  <LicenceSelectorQuestion
                    activeQuestions={[]}
                    question={question}
                    userAnswers={userAnswers}
                    setAnswer={(key, value, answer) => { this.props.setAnswer(key, value, question, answer); }}
                    clearAnswers={this.props.clearAnswers}
                    softwareLicencesMap={this.props.softwareLicencesMap}
                  />
                </ChildQuestionsWrapper>
              );
            })}
          </TextContainer>
        </TopRow>
        <DescriptionModal
          text={I10n.getOrDefault(`screen.licence_selector.modal.answer.hint.${answer.labelKey}`, answer.hint)}
          title={I10n.getOrDefault(`screen.licence_selector.modal.answer.name.${answer.labelKey}`, answer.name)}
          show={this.state.showModal}
          onClose={this.toggleModal}
        />
       </Card>
    );
  }
}

export default LicenceSelectorCheckCardV2;
